import lazySizes from 'lazysizes';

/**
 * Utilities to handle chapter images
 */
export default class Images {
	static create(chapter) {
		const images = chapter.content.querySelectorAll('[data-image]');

		if (!images.length) {
			return null;
		}

		return new Images(chapter);
	}

	constructor(chapter) {
		this.chapter = chapter;
	}

	getNotLoadedImages() {
		const platform = this.chapter.getPlatform();
		const selectors = {
			mobile: '[data-image="mobile"]:not(.lazyloaded), [data-image="both"]:not(.lazyloaded)',
			desktop: '[data-image="desktop"]:not(.lazyloaded), [data-image="both"]:not(.lazyloaded)',
		};

		return this.chapter.content.querySelectorAll(selectors[platform]);
	}

	loadImages(images) {
		const delay = 0;

		return new Promise(resolve => {
			if (!images.length) {
				resolve();
				return;
			}

			let counter = 0;
			const that = this;

			this.chapter.content.addEventListener('lazyloaded', function handleUnveil() {
				counter++;

				that.chapter.preloader.imageLoaded(images.length); // :(

				if (counter >= images.length) {
					this.removeEventListener('lazyloaded', handleUnveil);
					resolve(images);
				}
			});

			images.forEach((image, index) => {
				setTimeout(() => {
					lazySizes.loader.unveil(image);
				}, index * delay);
			});
		});
	}
}
